<script lang="ts">
import { Prop } from "@/helpers/Decorators";
import { KeyValuePair } from "@/helpers/Interfaces";
import { UserDisplayModel } from "@/modules/core/dictionaries/services/DictionaryService";
import { Options, Vue } from "vue-class-component";
import Participant from "@/modules/low-code/components/Participant.vue";

@Options({
    name: "UserWithAvatarFormatter",
    components: { Participant },
})
export default class UserWithAvatarFormatter extends Vue
{
    @Prop({ default: null }) public property: UserDisplayModel[];
    @Prop({ default: (): KeyValuePair[] => ([]) })public features: KeyValuePair[];
    @Prop({ default: false }) public isOnGrid: boolean;

    public showInfo(user: UserDisplayModel): void
    {
        this.$events.$emit("fetchUser", { id: user.key });
    }

    public getElements(targets: any[], visible: boolean = true): any[]
    {
        if (!targets) return [];

        return visible ? targets.slice(0, 5) : targets.slice(5);
    }
}
</script>

<template>
    <div v-if="property" class="d-flex align-items-center">
        <template v-if="property.length === 1">
            <UserAvatar
                :src="$filters.baseurl(`storage/files/${property[0].pictureUrl}`)"
                :username="`${property[0].value}`"
                rounded="circle"
                class="user-avatar"
                @click="showInfo(property[0])"
            />
            <span class="ms-2 user-name me-2" @click="showInfo(property[0])">{{ property[0].value }}</span>
        </template>
        <template v-else>
            <Participant v-for="user in getElements(property)" :key="user.id" :user="{ user }" custom-class="cursor-pointer" @click="showInfo(user)" />
            <IdeoDropdown
                v-if="getElements(property, false).length"
                boundary="body"
                variant="secondary"
                :top-offset="5"
                no-caret
            >
                <template #button-content>
                    <i class="fas fa-plus me-1"></i>
                    <span>{{ getElements(property, false).length }}</span>
                </template>
                <template #default>
                    <IdeoDropdownItemButton
                        v-for="(user, userIndex) in getElements(property, false)"
                        :key="userIndex"
                        @click.stop
                    >
                        <UserAvatar
                            :src="$filters.baseurl(`storage/files/${user?.pictureUrl}`)"
                            :username="user?.value"
                            :key="user?.pictureUrl"
                            class="cursor-pointer"
                        />
                        <div class="ms-2">
                            <p class="mb-0">
                                <strong class="text-primary cursor-pointer">
                                    <span>{{ user?.value }}</span>
                                </strong>
                            </p>
                        </div>
                    </IdeoDropdownItemButton>
                </template>
            </IdeoDropdown>
        </template>
    </div>
    <span v-else>-</span>
</template>

<style lang="scss">
.details-label {
    .user-avatar {
        cursor: pointer;
    }

    .user-name {
        cursor: pointer;
        color: var(--bs-link-color);

        &:hover {
            color: var(--bs-link-hover-color);
        }
    }
}
</style>
